export default {
    Enterprise: 'https://koach.kauveryhospital.com/company_screens/',
    Login: 'https://koach.kauveryhospital.com/userlogin_beta',
    CheckParallel: 'https://koach.kauveryhospital.com/check_device_token_beta',
    Area: 'https://koach.kauveryhospital.com/assigned_users',
    Fetch: 'https://koach.kauveryhospital.com/fetch_all_microstep_beta',
    Dashboard: 'https://koach.kauveryhospital.com/webservice/getDashboardData',
    MyAccount: 'https://koach.kauveryhospital.com/myaccount',
    AboutUs: 'https://koach.kauveryhospital.com/about-us',
    Privacy: 'https://koach.kauveryhospital.com/privacy-policy',
    ChangePassword: 'https://koach.kauveryhospital.com/change_my_password',

    LogOut: 'https://koach.kauveryhospital.com/logout_user',
    Forgot: 'https://koach.kauveryhospital.com/userforgotpassword',
    Check: 'https://koach.kauveryhospital.com/assigned_checklist',
    Observation: 'https://koach.kauveryhospital.com/assigned_observationlist',
    Suggestion: 'https://koach.kauveryhospital.com/assigned_suggestionlist',
    Groups: 'https://koach.kauveryhospital.com/get_network_list_for_user',
    GroupsTopicList: 'https://koach.kauveryhospital.com/knowledge_topic_list',
    UserReport: 'https://koach.kauveryhospital.com/user_report',
    TopArea: 'https://koach.kauveryhospital.com/top_knowledge_units',
    NotAttentedUnits: 'https://koach.kauveryhospital.com/not_attempted_units_by_user',
    UserAreaDropDown: 'https://koach.kauveryhospital.com/user_area_dropdown',
    AreaLevelInsight: 'https://koach.kauveryhospital.com/user_report_area',
    SubmitUnit: 'https://koach.kauveryhospital.com/save_time_spent_multi_beta',
    SubmitPauseUnit: 'https://koach.kauveryhospital.com/save_pause_session_multi',
    PauseUnit: 'https://koach.kauveryhospital.com/fetch_pause_session',
    PauseSession: 'https://koach.kauveryhospital.com/fetch_pause_session_details',
    DeletePauseUnit: 'https://koach.kauveryhospital.com/delete_pause_session',
    SearchUnit: 'https://koach.kauveryhospital.com/list_programs',
    Notification: 'https://koach.kauveryhospital.com/broadcast_msg_list',
    VideoConference: 'https://koach.kauveryhospital.com/video_notification',
    CheckVideoConference: 'https://koach.kauveryhospital.com/check_video_notification',
    NotificationPollUpdate: 'https://koach.kauveryhospital.com/update_poll_broadcast',
    NotificationUpdate: 'https://koach.kauveryhospital.com/broadcast_msg_update',
    Group_Notification: 'https://koach.kauveryhospital.com/group_notification',
    MakeStar: 'https://koach.kauveryhospital.com/make_stared_module',
    Star: 'https://koach.kauveryhospital.com/star_list',
    Record: 'https://koach.kauveryhospital.com/webservice/get_training_program_mobile_userid',
    Records: 'https://koach.kauveryhospital.com/webservice/get_training_program_mobile',
    Location: 'https://koach.kauveryhospital.com/webservice/get_all_location',
    Attandance: 'https://koach.kauveryhospital.com/webservice/training_attendance'
}